import { api } from "./index";

export async function fetchSetupStatus() {
  const response = await api.get("/onboarding/setup-status");
  return response.data;
}
